<template>
  <el-card
    header="Manifest Calculated Pricing"
    shadow="never"
  >
    <template slot="header">
      <div class="clearfix">
        <span>Manifest Calculated Pricing</span>
        &nbsp;
        <el-tooltip
          class="item"
          effect="dark"
          content="This pricing is calculated when the consignment is manifested for internal use only. It is never shown to the customer"
          placement="right-start"
        >
          <i class="el-icon-info" />
        </el-tooltip>
        <!-- <el-button-group style="float: right;">
          <el-button
            v-clipboard:copy="pricingDetails"
            v-clipboard:success="() => $message.success('Pricing copied to clipboard')"
            style="padding: 3px 0"
            type="text"
          >
            Copy
          </el-button>
        </el-button-group> -->
      </div>
    </template>
    <el-table
      :data="pricing"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="carrier_name"
        label="Carrier"
        sortable
      />
      <el-table-column
        prop="service"
        label="Service"
        sortable
        :formatter="(row, col, cellValue) => row.service_name + ` [${row.service}]`"
      />
      <el-table-column
        prop="est_cost_ex"
        label="Rate"
        sortable
      />
      <el-table-column
        prop="est_cost_fuel"
        label="Fuel"
        sortable
      />
      <el-table-column
        prop="est_cost_fees"
        label="Fees"
        sortable
      />
      <el-table-column
        prop="est_cost_tax"
        label="Tax"
        sortable
      />
      <el-table-column
        prop="est_ett"
        label="ETT"
        sortable
      />
      <el-table-column
        prop="est_cost_fees_desc"
        label="Fee Description"
        sortable
      />
      <el-table-column
        prop="source"
        label="Source"
        sortable
      />
    </el-table>
  </el-card>
</template>
<script>
export default {
  props: {
    pricing: {
      type: Array,
      default: () => []
    }
  }
}
</script>
